import React from "react";

export const PageHero = ({ overline, title, subtitle, image, children }) => (
  <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-20 overflow-hidden bg-navy-900">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/70 to-navy-900/40" />
      </>
    )}
    <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      {overline && <span className="text-xs font-bold uppercase tracking-[0.25em] text-gold-light">{overline}</span>}
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white mt-4 tracking-tight max-w-4xl leading-[1.05]">{title}</h1>
      {subtitle && <p className="mt-5 text-lg text-slate-300 max-w-2xl leading-relaxed">{subtitle}</p>}
      {children}
    </div>
  </section>
);
